// extracted by mini-css-extract-plugin
module.exports = {"prefetching-wrapper":"prefetching-wrapper_prefetching-wrapper__flGra"};